export default __webpack_public_path__ + "static/media/notif_paciente.5bf81a17.wav";